module.exports = __webpack_public_path__ + "img/icon-camera.98bac448.svg";